import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-1bf8f4a7")
const _hoisted_1 = { class: "card kpi_header" }
const _hoisted_2 = { class: "kpi_header__back_and_title" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h5", { class: "p-my-0" }, "KPI", -1)
const _hoisted_4 = { class: "kpi_header__filters_and_actions" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackButton = _resolveComponent("BackButton")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_FloatLabel = _resolveComponent("FloatLabel")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_BackButton, { class: "p-mr-3" }),
      _hoisted_3
    ]),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true),
      _createVNode(_component_FloatLabel, {
        label: _ctx.$t('admin_kpi.date_range'),
        class: "p-mr-sm-3"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Calendar, {
            manualInput: false,
            modelValue: _ctx.dateRange,
            showIcon: true,
            inputStyle: "min-width: 13rem;",
            selectionMode: "range",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:dateRange', $event))),
            onDateSelect: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('date-select', $event)))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_Button, {
        label: _ctx.$t('admin_kpi.refresh'),
        icon: "pi pi-refresh",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('refresh')))
      }, null, 8, ["label"])
    ])
  ]))
}